import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Link } from '@alfa-bank/site-link';
import { Grid } from '@alfa-bank/site-grid-universal';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';
import { LogoDesktop as Logo } from '@alfa-bank/site-invest-emitents-common/components/logo-desktop';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import { ProfitabilityCellDesktop as ProfitabilityCell } from '../cells/profitability/desktop';

import { AssetCard as Component } from './component';
import type { IDepsDesktop, TAssetCardDesktop } from './models';
import styles from './styles.css';

export const AssetCardDesktop = createWidget<IDepsDesktop, TAssetCardDesktop>({
    Grid,
    Link,
    Block,
    Logo,
    ProfitabilityCell,
    Text,
    styles,
})(Component);
